<!-- Carrier Details Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-truck me-2"></i>
        Dettagli Vettore<ng-container *ngIf="carrier">: {{ carrier.carrierName || carrier.carrierCode }}</ng-container>
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">

      <!-- Caricamento -->
      <div class="state-box" *ngIf="isLoading">
        <i class="fas fa-spinner fa-spin fa-2x text-muted mb-3"></i>
        <p class="mb-0 text-muted">Caricamento dati vettore...</p>
      </div>

      <!-- Errore -->
      <div class="state-box" *ngIf="!isLoading && hasError">
        <i class="fas fa-exclamation-triangle fa-2x text-danger mb-3"></i>
        <p class="mb-1 fw-semibold">Impossibile recuperare i dati del vettore</p>
        <p class="text-muted mb-0 small">Codice vettore: {{ carrierCode }}</p>
      </div>

      <div class="carrier-details" *ngIf="!isLoading && !hasError && carrier">

        <!-- Header riepilogo -->
        <div class="details-summary">
          <div class="details-summary-item">
            <i class="fas fa-truck"></i>
            <span>Vettore: <strong>{{ carrier.carrierName || carrier.carrierCode }}</strong></span>
          </div>
          <div class="details-summary-item" *ngIf="carrier.carrierOperatingAddressCity">
            <i class="fas fa-city"></i>
            <span>{{ carrier.carrierOperatingAddressCity }}<ng-container *ngIf="carrier.carrierOperatingAddressProvince"> ({{ carrier.carrierOperatingAddressProvince }})</ng-container></span>
          </div>
          <div class="details-summary-item" *ngIf="carrier.carrierStatus">
            <span class="details-status-badge" [ngClass]="getStatusBadgeClass()">
              <i class="fas fa-circle status-dot"></i>
              {{ carrier.carrierStatus }}
            </span>
          </div>
        </div>

        <!-- Identificazione -->
        <div class="details-card">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-id-card"></i></div>
            <h5 class="details-card-title">Identificazione</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item">
                <span class="details-label">Codice Vettore</span>
                <div class="details-value details-value--code">
                  <span>{{ carrier.carrierCode || '-' }}</span>
                  <i *ngIf="carrier.carrierCode" class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(carrier.carrierCode)" title="Copia codice vettore"></i>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Ragione Sociale</span>
                <div class="details-value">
                  <span>{{ carrier.carrierName || '-' }}</span>
                  <i *ngIf="carrier.carrierName" class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(carrier.carrierName)" title="Copia ragione sociale"></i>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">ID Interno</span>
                <div class="details-value details-value--code">
                  <span>{{ carrier.carrierInternalId || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Dati Fiscali -->
        <div class="details-card" *ngIf="carrier.carrierVatNumber || carrier.carrierSdiCode || carrier.carrierInternalBillingId">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-file-invoice-dollar"></i></div>
            <h5 class="details-card-title">Dati Fiscali</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item" *ngIf="carrier.carrierVatNumber">
                <span class="details-label">Partita IVA</span>
                <div class="details-value details-value--code">
                  <span>{{ carrier.carrierVatNumber }}</span>
                  <i class="fas fa-copy copy-icon" (click)="copyToClipboard(carrier.carrierVatNumber)" title="Copia partita IVA"></i>
                </div>
              </div>
              <div class="details-item" *ngIf="carrier.carrierSdiCode">
                <span class="details-label">Codice SDI</span>
                <div class="details-value details-value--code">
                  <span>{{ carrier.carrierSdiCode }}</span>
                  <i class="fas fa-copy copy-icon" (click)="copyToClipboard(carrier.carrierSdiCode)" title="Copia codice SDI"></i>
                </div>
              </div>
              <div class="details-item" *ngIf="carrier.carrierInternalBillingId">
                <span class="details-label">ID Fatturazione</span>
                <div class="details-value details-value--code">
                  <span>{{ carrier.carrierInternalBillingId }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Indirizzo Legale -->
        <div class="details-card" *ngIf="hasLegalAddress()">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-building"></i></div>
            <h5 class="details-card-title">Indirizzo Legale</h5>
          </div>
          <div class="details-card-body">
            <div class="details-value details-value--stacked">
              <div *ngIf="carrier.carrierLegalAddressStreet">
                <i class="fas fa-road me-1 text-muted"></i>
                {{ carrier.carrierLegalAddressStreet }} {{ carrier.carrierLegalAddressNumber }}
              </div>
              <div *ngIf="carrier.carrierLegalAddressZip || carrier.carrierLegalAddressCity">
                <i class="fas fa-city me-1 text-muted"></i>
                {{ carrier.carrierLegalAddressZip }} {{ carrier.carrierLegalAddressCity }}
                <ng-container *ngIf="carrier.carrierLegalAddressProvince">({{ carrier.carrierLegalAddressProvince }})</ng-container>
              </div>
              <div *ngIf="carrier.carrierLegalAddressCountry">
                <i class="fas fa-globe-europe me-1 text-muted"></i>
                {{ carrier.carrierLegalAddressCountry }}
              </div>
            </div>
          </div>
        </div>

        <!-- Indirizzo Operativo -->
        <div class="details-card" *ngIf="hasOperatingAddress()">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-warehouse"></i></div>
            <h5 class="details-card-title">Indirizzo Operativo</h5>
          </div>
          <div class="details-card-body">
            <div class="details-value details-value--stacked">
              <div *ngIf="carrier.carrierOperatingAddressStreet">
                <i class="fas fa-road me-1 text-muted"></i>
                {{ carrier.carrierOperatingAddressStreet }} {{ carrier.carrierOperatingAddressNumber }}
              </div>
              <div *ngIf="carrier.carrierOperatingAddressZip || carrier.carrierOperatingAddressCity">
                <i class="fas fa-city me-1 text-muted"></i>
                {{ carrier.carrierOperatingAddressZip }} {{ carrier.carrierOperatingAddressCity }}
                <ng-container *ngIf="carrier.carrierOperatingAddressProvince">({{ carrier.carrierOperatingAddressProvince }})</ng-container>
              </div>
              <div *ngIf="carrier.carrierOperatingAddressCountry">
                <i class="fas fa-globe-europe me-1 text-muted"></i>
                {{ carrier.carrierOperatingAddressCountry }}
              </div>
              <a *ngIf="hasCoordinates()" [href]="getCoordinatesMapUrl()" target="_blank" class="btn btn-sm btn-outline-primary mt-2">
                <i class="fas fa-external-link-alt me-1"></i>Apri in Google Maps
              </a>
            </div>
          </div>
        </div>

        <!-- Informazioni Aggiuntive -->
        <div class="details-card">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-info-circle"></i></div>
            <h5 class="details-card-title">Informazioni Aggiuntive</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item">
                <span class="details-label">Stato</span>
                <div class="details-value">
                  <span class="details-status-badge" *ngIf="carrier.carrierStatus; else noStatus" [ngClass]="getStatusBadgeClass()">
                    <i class="fas fa-circle status-dot"></i>
                    {{ carrier.carrierStatus }}
                  </span>
                  <ng-template #noStatus><span class="text-muted">-</span></ng-template>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Settore</span>
                <div class="details-value">{{ carrier.carrierIndustry || '-' }}</div>
              </div>
              <div class="details-item">
                <span class="details-label">Data Costituzione</span>
                <div class="details-value">{{ carrier.carrierIncorporationDate ? (carrier.carrierIncorporationDate | date:'dd/MM/yyyy') : '-' }}</div>
              </div>
              <div class="details-item" *ngIf="carrier.carrierCreatedAt">
                <span class="details-label">Data Creazione</span>
                <div class="details-value">{{ carrier.carrierCreatedAt | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Note -->
        <div class="details-card" *ngIf="carrier.carrierNote">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-sticky-note"></i></div>
            <h5 class="details-card-title">Note</h5>
          </div>
          <div class="details-card-body">
            <div class="details-notes">{{ carrier.carrierNote }}</div>
          </div>
        </div>

      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
